<template>
  <v-container v-if="importInfoId">
    <v-alert
      outlined
      prominent
      text
      :type="isPartialSuccess ? 'warning' : 'success'"
      dismissible
    >
      <template #prepend>
        <v-icon
          :color="isPartialSuccess ? 'warning' : 'success'"
          left
          class="mr-4"
        >
          $vuetify.icons.info
        </v-icon>
      </template>
      <template #default>
        <span v-if="isPartialSuccess">{{ $t('page.importExamsInfo.textPartial') }}</span>
        <span v-else>{{ $t('page.importExamsInfo.textSuccess') }}</span>
        &nbsp;
        <a @click="onDownloadReport">{{ $t('page.importExamsInfo.link') }}</a>
        <span v-if="isPartialSuccess">
          <br>
          <b>{{ $t('page.importExamsInfo.additionalTextPartial') }}</b>
        </span>
      </template>
    </v-alert>
  </v-container>
</template>

<script>
import fileDownload from "js-file-download";

export default {
  name: 'ExamsImportReportAlert',

  inject: [
    'imports'
  ],

  props: {
    importInfoId: {
      type: String,
      default: null
    },
    isPartialSuccess: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    async onDownloadReport() {
      const response = await this.imports.downloadExamsExcelReport(this.importInfoId)
      const filename = this.getFilenameFromHeaders(response.headers, 'pruefungen.xlsx')
      fileDownload(response.data, filename)
    },

    getFilenameFromHeaders(headers, defaultFilename) {
      if (!headers) {
        return defaultFilename
      }

      const contentDispositionHeader = headers['content-disposition']
      if (!contentDispositionHeader) {
        return defaultFilename
      }

      if (contentDispositionHeader.indexOf('attachment') == -1) {
        return defaultFilename
      }

      const filenameRegex = /filename="([^"]+)"/
      const matches = filenameRegex.exec(contentDispositionHeader)
      if (!matches || !matches[1]) {
        return defaultFilename
      }

      return matches[1]
    }
  }
}
</script>
